<template>
    <div class="welcome-all">
        <div class="welcome-to">
            <div class="welcome-img"></div>
            <div class="welcome-text">
                <div class="welcome-position">
                    <div class="welcome-title">{{ $t('language.addCloud.welcomeTo') }}</div>
                    <div class="welcome-font">{{ $t('language.addCloud.welcomeFont') }}</div>
                    <button class="welcome-botton " @click.stop="addCloud()">
                        <div class="icon addCloudIcon add-icon-position"></div>{{ $store.state.isLiteMode ? $t('language.leftBanner.addCloud') : $t('language.leftBanner.addEmail') }}
                    </button>
                </div>
            </div>
        </div>
        <div class="welcome-bottom"></div>
    </div>
</template>

<script>
export default {
    methods: {
        addCloud() {
            this.$emit('addCloud');
        }
    }
}
</script>

<style>
.welcome-all {
    width: 100%;
    height: 100%;
    position: relative;
}

.welcome-to {
    width: 980px;
    /*no*/
    height: 310px;
    /*no*/
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}

.welcome-img {
    float: left;
    width: 425px;
    /*no*/
    height: 306px;
    /*no*/
    background-image: url("../../assets/images/new_user.png");
}

.welcome-text {
    float: left;
    width: 380px;
    /*no*/
    margin-left: 120px;
    /*no*/
    height: 100%;
    position: relative;

}

.welcome-position {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    height: 85%;

}

.welcome-title {
    font-size: 26px;
    /*no*/
    font-weight: 500;
    color: #000;
}

.welcome-font {
    margin-top: 45px;
    /*no*/
    font-size: 16px;
    /*no*/
    color: #6f7886;
    line-height: 30px;
    /*no*/
}

.welcome-botton {
    margin-top: 45px;
    /*no*/
    font-size: 16px;
    /*no*/
    height: 40px;
    /*no*/
    line-height: 40px;
    /*no*/
    padding-left: 30px !important;
    padding-right: 20px !important;
}

.welcome-bottom {
    width: 100%;
    height: 25%;
    background-image: url("../../assets/images/workspace/task.png");
    background-size: cover;
    position: absolute;
    bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/home_add_drive.vue